// Swiperの初期化（プレーンJS版）
// @see vendorの読み込みでグローバルにSwiperが利用可能であることが前提

const initPhotoStudioSwiper = () => {
  if (!document.querySelector('.js-photo-studio-swiper')) return;
  if (typeof window.Swiper !== 'function') return;

  // eslint-disable-next-line no-undef
  new Swiper('.js-photo-studio-swiper', {
    slidesPerView: 'auto', // 1枚表示（= スクロールで1枚ずつ）
    loop: true,
    speed: 500,
    spaceBetween: 20,
    allowTouchMove: false, // スワイプ（タッチ/ドラッグ）を無効化
    simulateTouch: false, // マウスドラッグによるスワイプも無効化
    mousewheel: {
      invert: false,
    },
  });

  // クリック/ドラッグ操作を無効化したい場合は必要に応じて有効化
  // swiper.allowTouchMove = false;
};

export { initPhotoStudioSwiper };
